import styled from "styled-components";

export const MobileTournamentWrapper = styled.div`
  height: 100dvh;
  box-sizing: border-box;
  padding: 68px 16px 99px;
  overflow-y: auto;
`;

export const MobileTournamentBackground = styled.div`
  background: #f0f3f8;
  border-radius: 8px;
`;

export const MobileTournamentTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px;
  box-sizing: border-box;
`;

export const MobileTournamentItem = styled.div`
  width: 100%;
  min-height: 97px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  gap: 9px;

  > .title {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    min-height: 34px;
    display: flex;
    align-items: center;
  }
`;

export const MobileTournamentItemHeader = styled.div`
  display: flex;
  justify-content: space-between;

  > .des {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 103px;
    padding: 8px 0;
    border-radius: 10px;
    background-color: #383a54;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  > .des.end {
    background: #bebebe;
  }
  > .des.starting {
    background: #fe5cee;
  }
  > .des.stop {
    background:
      linear-gradient(103deg, #6c36d6 -22.02%, #955fff 54.56%, #ccb2ff 102.58%),
      #bebebe;
  }
  > .des.lv {
    background:
      linear-gradient(103deg, #6c36d6 -22.02%, #955fff 54.56%, #ccb2ff 102.58%),
      #bebebe;
  }

  > .right {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

export const MobileTournamentItemDropBox = styled.div`
  position: relative;

  > img {
    transform: rotate(90deg);
  }

  > .wrapper {
    position: absolute;
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    border-radius: 15px;
    background: #fff;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
    z-index: 999;

    > .item {
      display: flex;
      padding: 8px 14px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      white-space: nowrap;
      border-radius: 15px;
      border: 1px solid #f0f0f0;
      color: #202020;
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;
